/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2019-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import './input.scss';
import FormLabel from "../label/FormLabel";
import { getSizeOptions } from '../formUtils/formUtils';

class Input extends Component {
    render() {
        let {
            name, type, value, label, description, placeholder, className, $field, $validation, onChange, onBlur,
            horizontalInput, minNumber, disabled, style, labelStyle, unit, autoComplete, mandatory, errorColor,
            onFocus, onClick, fieldSizes, labelSizes,
        } = this.props;
        const inputStyle = () => {
            if (get($validation, `['${name}'].show`) && get($validation, `['${name}'].isValid`) === false) {
                return {
                    borderColor: errorColor
                }
            }
            return {}
        }
        const errorStyle = () => {
            if (get($validation, `['${name}'].show`) && get($validation, `['${name}'].isValid`) === false) {
                return {
                    color: errorColor
                }
            }
            return {}
        }
        let inputClass = () => {
            let out = 'form-control';
            if (get($validation, `['${name}'].show`) && get($validation, `['${name}'].isValid`) === false) {
                out = 'form-control invalid-input'
            }
            if (this.props.unit) {
                out += ' input-units-padding';
            }
            if (this.props.type === 'color') {
                // override padding for color pickers
                out += ' p0'
            }
            return out;
        };

        let wrapperClass = `${horizontalInput ? '' : 'form-group'} from-input ${this.props.wrapperClass || ''}`;
        const isDisabled = disabled && disabled() ? {disabled: true} : {};
        style = style ? {style} : {};
        onBlur = onBlur ? onBlur : () => {
        };
        const fields = $field ? {...$field(name, (e) => onChange(name, e.target.value), (e) => onBlur(name, e.target.value))} : {};
        const sizeOptions = getSizeOptions(fieldSizes, labelSizes, 'input');
        return (
            <Row className={wrapperClass} {...style}>
                {label && (
                    <Col className={labelStyle} {...sizeOptions.label}>
                        <FormLabel label={label} mandatory={mandatory} htmlFor={name}
                                                            description={description} id={`${name}-${label}`}/>
                    </Col>
                )}
                <Col className={`container-input ${className ? className : ''}`} {...sizeOptions.field}>
                    <input
                        name={name}
                        type={type}
                        min={minNumber}
                        className={inputClass()}
                        placeholder={placeholder}
                        value={value}
                        style={inputStyle()}
                        autoComplete={autoComplete || (type === 'password' ? 'new-password' : 'off')}
                        onFocus={onFocus}
                        onClick={onClick}
                        {...isDisabled}
                        onChange={onChange}
                        {...fields}
                        aria-label={name}
                        id={name}
                        aria-describedby={`${name}-${label}`}
                    />
                    <div style={errorStyle()} className="error-message">{get($validation, `['${name}'].show`) && <span>{$validation[name].error.reason}</span>}</div>
                    {unit ? <div className="placeholder-units">{unit}</div> : null}
                </Col>
                <div className="clearfix" />
            </Row>
        );
    }
}

Input.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    value: PropTypes.string || PropTypes.number,
    label: PropTypes.string,
    description: PropTypes.string,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    '$validation': PropTypes.object,
    '$field': PropTypes.func,
    horizontalInput: PropTypes.bool,
    minNumber: PropTypes.number,
    disabled: PropTypes.func,
    style: PropTypes.object,
    labelStyle: PropTypes.string,
    unit: PropTypes.string,
    wrapperClass: PropTypes.string,
    onChange: PropTypes.func,
    onCLick: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    fieldSizes: PropTypes.object,
    labelSizes: PropTypes.object,
};

export default Input;
